import styled, { createGlobalStyle } from 'styled-components';

import { StyledModalDialog, token } from '@zillow/constellation';

export const StyledContainer = styled.div`
    background-color: ${token('colors.gray100')};
`;

export const StyledFooterContainer = styled.div`
    background-color: ${token('colors.white')};
    /* Investigate why the zrs-comet Footer doesn't work as is */
    ul {
        columns: 1;
        column-width: auto;
    }
    li {
        display: inline-block;
        margin: 0px 10px;
    }
`;

export const GlobalStyle = createGlobalStyle`
    html, body {
        overflow: auto !important;
    }
    ${StyledModalDialog} {
        &&& {
            section > button {
                color: #001751;
                width: 24px;
                height: 24px;
                > svg {
                    width: 24px;
                    height: 24px;
                }
            }
        }
    }
`;
